import Vue from 'vue'

export default async (action, products, month, reference_id = null) => {
  const data = {
    action: action,
    products: products,
    interval_count: month,
    reference_id: reference_id
  }
  const res = await Vue.axios.post(`/billing/calculation`, data)
  return res.data
}



// WEBPACK FOOTER //
// ./src/services/billing/get-price.js